
import React, { useEffect } from 'react';
import { Row, Col, Button, CloseButton } from 'react-bootstrap';
import { CurrencyInput, TextInput, DropDown } from '../../../../../../../../../components/form/form';
import styles from './selling-agent-allocation.module.scss';
import addButton from '../../../../../../../../../assets/add-button.svg';
import closeButton from '../../../../../../../../../assets/close.svg';

/*
  Render Multiple Dynamic Security Allocation Field
  Pass participantFormState obj for the allocation field update
*/
const SellingAgentAllocation = ({ securityList, participantFormState, isEditable=true }) => {
  const { getDynamicField, getTextFieldPropsDynamic, getDropdownPropsDynamic, setDynamicField } = participantFormState;
  const required = (name) => <a>{name}<a className={styles['red']}>*</a></a>;
  const securityOptions = securityList.map((value,index)=>{return {name: value.prefShortName, value: index}});

  /*
    Add an empty allocation object to the participantFormState obj.
    Will put an allocation obj in the dynamic field.
  */
  const addAllocation = () => {
    const allocation = getDynamicField('allocation').concat({
      securityIndex: {value: '', style: {}},
      amount: {value: '', style: {}}
    });
    setDynamicField('allocation', allocation);
  }

  /*
    Splice the last allocation field entry.
    Will remove the last allocation field entry.
  */
  const removeAllocation = (index) => {
    var allocation = getDynamicField('allocation');
    var array = [...allocation];
    array.splice(index, 1);
    setDynamicField('allocation', array);
  }

  /*
    Render add security allocation button
  */
  const renderButton = (index) => {
    const fieldLength = getDynamicField('allocation').length;
    if( fieldLength > 1 && index < fieldLength - 1 && isEditable ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>removeAllocation(index)} src={closeButton}/>
        </div>
      )
    }
    if( (fieldLength - 1) == index  && isEditable ){
      return (
        <div className={styles['button']}>
          <img onClick={()=>addAllocation(index)} src={addButton}/>
        </div>
      )
    }
  }

  return (
    <div className={styles['sa-allocation']}>
      {
        getDynamicField('allocation').map((_,index)=>{
          return (
            <>
              <Row key={'allocation-'+index} className="mt-1">
                <Col sm={6} lg={4}>
                  <DropDown
                    disabled={!isEditable}
                    inputProps={getDropdownPropsDynamic('allocation','securityIndex', index)}
                    values={securityOptions}>
                    {required("Security:")}
                  </DropDown>
                </Col>
                <Col sm={6} lg={4}>
                  <CurrencyInput
                    inputProps={getTextFieldPropsDynamic('allocation','amount', index)}
                    placeholder="0.00">
                    {required("Allocation:")}
                  </CurrencyInput>
                </Col>
                { renderButton(index) }
              </Row>
            </>
          )
        })
      }
    </div>
  )
}

export default SellingAgentAllocation;


